module.exports = __webpack_public_path__ + "img/pause-icon.a346b1d2.svg";